import { render, staticRenderFns } from "./Subtotal.vue?vue&type=template&id=047c581a&scoped=true"
import script from "./Subtotal.vue?vue&type=script&lang=js"
export * from "./Subtotal.vue?vue&type=script&lang=js"
import style0 from "./Subtotal.vue?vue&type=style&index=0&id=047c581a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c581a",
  null
  
)

export default component.exports